<template>
  <div class="cards">
    <myScroll>
      <div class="promosBlock">
        <div class="promo" v-if="files">
          <div class="content noborder">
            <Filebrowser :data="data" @set="$emit('set', { key: keys, value: $event, type: 'add' })"/>
          </div>
        </div>
        <div class="promo" v-for="(item, i) in files ? data[keys].value : items" :key="i">

          <div class="content" :class="{active: removeData && (removeData.id === item.id)}">
            <div class="controlls" :class="{full: !edit || !remove}">
              <div class="controll first" @click="$emit('edit', item)" v-if="edit" title="Изменить">
                <EditIcon/>
              </div>
              <div class="controll first fill" @click="$emit('day', item)" v-if="day"
                   :class="{active: item.guide_of_the_day}" title="Гайд дня">
                <PercentIcon/>
              </div>
              <div class="controll last"
                   @click="$emit('remove', files ? { key: keys, value: i, id: item.id, type: 'remove' } : item)"
                   v-if="remove" title="Удалить">
                <TrashIcon/>
              </div>
            </div>
            <div class="center">
              <div class="code" v-if="promo" title="Код">
                {{ item.code }}
              </div>
              <div class="discount" v-if="promo" title="Скидка">
                {{ item.type !== 3 ? `${item.discount} ${(item.type) === 1 ? '%' : '₽'}` : '3 за 2' }}
              </div>
              <div class="image" v-if="!promo">
                <img :src="getRoute(item)" v-if="!guide"/>
                <img :src="getCover(item, item.gallery)" v-if="guide"/>
              </div>
            </div>
            <div class="bottom" v-if="promo && !counts"
                 :class="{off: !getValidDate(item.date), on: getValidDate(item.date)}">
              {{ getValidDate(item.date) ? 'Истекает' : 'Истек' }} {{ getDate(item.date) }}
            </div>
            <div v-if="promo" class="bottom">
              Использован <span>{{ item.counter ? item.counter : 0 }}</span> раз(а)
            </div>
            <div class="bottom" v-if="!promo && !button">
              {{ item.title || '' }}
            </div>
            <div class="bottom button" v-if="!promo && files && button"
                 @click="$emit('set', { key: keys, value: i, type: 'cover' })"
                 :class="{active: (data.cover.value - 1) === i}">
              {{ (data.cover.value - 1) === i ? 'Добавлено на обложку' : 'Добавить на обложку' }}
            </div>
          </div>
        </div>
      </div>
    </myScroll>
    <Loader v-if="loader"/>
  </div>
</template>

<script>
import EditIcon from '@/assets/svg/edit-icon.svg?inline'
import TrashIcon from '@/assets/svg/trash-icon.svg?inline'
import PercentIcon from '@/assets/svg/percent-icon.svg?inline'
import Filebrowser from '@/components/ui/Filebrowser'
import Loader from '@/components/Loader'

export default {
  components: {
    EditIcon,
    TrashIcon,
    Filebrowser,
    PercentIcon,
    Loader
  },
  props: {
    removeData: Object,
    data: Object,
    files: Boolean,
    items: Array,
    remove: Boolean,
    edit: Boolean,
    promo: Boolean,
    button: Boolean,
    keys: String,
    day: Boolean,
    loader: Boolean,
    guide: Boolean,
    counts: Boolean
  },
  methods: {
    getRoute(value) {
      if (!value) {
        return require('@/assets/demo1.webp');
      }
      if (value.id && value.data) {
        // If value.data is already a full URL, use it as is
        if (value.data.startsWith('http://') || value.data.startsWith('https://')) {
          return value.data;
        }
        // Otherwise, construct the URL using the backend URL
        const backendUrl = process.env.VUE_APP_BACKEND_URL || process.env.VUE_APP_SERVER || '';
        // Remove trailing slash from backendUrl and leading slash from value.data if needed
        const cleanBackendUrl = backendUrl.replace(/\/$/, '');
        const cleanImagePath = value.data.startsWith('/') ? value.data : '/' + value.data;
        return cleanBackendUrl + cleanImagePath;
      }
      return value.data || require('@/assets/demo1.webp');
    },
    getValidDate(date) {
      if (new Date().getTime() > Number(date)) {
        return false
      }
      return true
    },
    getDate(date) {
      const newDate = new Date(Number(date))
      return `${newDate.getDate().toString().padStart(2, '0')}.${(newDate.getMonth() + 1).toString().padStart(2, '0')}.${newDate.getFullYear()}`
    },
    getCover(item, files) {
      let result = null
      files.forEach((file, i) => {
        if ((Number(item.cover) - 1) === i) result = this.getRoute(file)
      })
      return result ? result : files.length > 0 ? this.getRoute(files[0]) : require('@/assets/demo1.webp');
    }
  }
}
</script>

<style lang="scss" scoped>
.cards {
  @include box(100%, 100%, relative, null, null, null, null, null, null);
  @include flex(left, top, row);

  .promosBlock {
    @include box(100%, 100%, relative, null, null, null, null, null, null);
    @include flex(left, top, row);
    @include padding(0, 0, 0, 0);
    flex-wrap: wrap;

    .promo {
      @include box(20%, auto, relative, null, null, null, null, null, null);
      @include padding(0, 0, 0, 0);

      .content {
        @include box(100%, 100%, relative, null, null, null, null, null, $card);
        @include border(0.04vw, solid, $cardBorder, null, null, null, null);
        transition: 0.3s;
        overflow: hidden;
        user-select: none;

        &.noborder {
          border: 0;
          @include size(auto, 14.1vw);
        }

        .controlls {
          @include box(100%, null, relative, null, null, null, null, null, null);
          @include flex(left, center, row);
          @include border(null, solid, $cardControllBorder, null, null, null, 0.04vw);
          z-index: 3;

          .controll {
            @include box(50%, 3vw, relative, null, null, null, null, null, $cardControll);
            @include flex(center, center, row);
            cursor: pointer;
            transition: 0.3s;

            svg {
              @include size(0.9vw, 0.9vw);

              path {
                stroke: $cardControllColor;
              }
            }

            &.active {
              @include box(null, null, null, null, null, null, null, null, $cardControllEditHover);

              svg path {
                fill: $cardControllEditColorHover;
                stroke: $cardControllEditColorHover;
              }
            }

            &.first {
              @include border(null, solid, $cardControllBorder, null, null, 0.04vw, null);

              &:hover {
                @include box(null, null, null, null, null, null, null, null, $cardControllEditHover);

                svg path {
                  stroke: $cardControllEditColorHover;
                }
              }

              &.fill {
                &:hover {
                  svg path {
                    fill: $cardControllEditColorHover;
                  }
                }
              }
            }

            &.last {
              &:hover {
                @include box(null, null, null, null, null, null, null, null, $cardControllRemoveHover);

                svg path {
                  stroke: $cardControllRemoveColorHover;
                }
              }
            }
          }

          &.full {
            .controll {
              @include box(100%, null, relative, null, null, null, null, null, $cardControll);

              &:first-child {
                @include border(0, solid, $cardControllBorder, null, null, null, null);
              }
            }
          }
        }

        .center {
          @include box(100%, null, relative, null, null, null, null, null, $white);
          @include flex(center, center, column);
          @include padding(0, 1vw, 0, 1vw);
          box-shadow: $cardBorderImageShadow;
          z-index: 2;

          img {
            @include box(auto, 100%, relative, null, null, null, null, null, null);
          }

          .code {
            @include padding(null, 1vw, null, 0.5vw);
            @include text(0.8vw, 500, 0.05vw, null, center, $cardCodeColor);
          }

          .discount {
            @include padding(null, 0.5vw, null, 1vw);
            @include text(0.8vw, 500, 0.05vw, null, center, $cardDiscountColor);
          }

          .image {
            @include box(100%, 6vw, relative, null, null, null, null, null, null);
            @include flex(center, center, row);
            overflow: hidden;

            img {
              @include box(auto, 100%, relative, null, null, null, null, null, null);
            }
          }
        }

        .bottom {
          @include box(100%, 3vw, relative, null, null, null, null, null, $cardBottom);
          @include flex(center, center, row);
          @include text(0.7vw, 400, 0.05vw, null, center, $cardBottomColor);
          text-transform: uppercase;

          span {
            font-weight: bold;
            @include padding(1vw, 0, 1vw, 0);
          }

          &.on {
            @include text(null, null, null, null, null, $cardBottomColorOn);
          }

          &.off {
            @include text(null, null, null, null, null, $cardBottomColorEnd);
          }

          &.button {
            @include box(null, null, relative, null, null, null, null, null, $cardBottomButton);

            &:hover {
              @include box(null, null, relative, null, null, null, null, null, $cardBottomHover);
              @include text(null, null, null, null, null, $cardBottomColorHover);
              cursor: pointer;
            }

            &.active {
              @include box(null, null, null, null, null, null, null, null, $cardBottomActive);
              @include text(null, null, null, null, null, $cardBottomColorActive);
              cursor: default;
            }
          }
        }

        &:hover, &.active {
          transform: scale(0.95);
          box-shadow: $cardHoverShadow;
        }
      }
    }
  }
}
</style>
